import './App.css';

import SignUpForm from './components/sign-up-confirmation/SignUpForm';

function App() {
  return (
    <div className="App">
      <div className="some">
            <SignUpForm/>
      </div>
    </div>
  );
}

export default App;
